import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomersWhoCameBackWidget } from '../../models/loyalty-dashboard.model';

@Component({
  selector: 'app-customers-who-came-back-widget',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="stat-card">
      <span class="stat-card__label">Customers who came back</span>
      <ng-container *ngIf="data as widget; else noData">
        <span class="stat-card__value">{{ widget.returnRate | number : '1.0-0' }}%</span>
        <span class="stat-card__detail">
          within {{ widget.windowDays }} days
          <ng-container *ngIf="widget.peerMedianReturnRate != null">
            · {{ widget.peerGroupLabel | lowercase }} median
            <strong>{{ widget.peerMedianReturnRate | number : '1.0-0' }}%</strong>
          </ng-container>
        </span>
      </ng-container>
      <ng-template #noData>
        <p class="stat-card__empty">No data available.</p>
      </ng-template>
    </div>
  `,
  styleUrl: '../stat-card.scss',
})
export class CustomersWhoCameBackWidgetComponent {
  @Input() data: CustomersWhoCameBackWidget | null = null;
}
